// White-label configuration. Change these values to rebrand the tool.
export const BRAND = {
  name: "CORTEX",
  suffix: "WEB",
  tagline: "Live website preview & review",
  accent: "#2f7bf6",
};
